import React from "react";
import { Helmet } from "react-helmet-async";

const DiscreetDelivery = () => {
  return (
    <>
      {/* 🔥 SEO META TAGS */}
      <Helmet>
        <title>
          100% Discreet Delivery in India | Safe & Private Shipping – LushDesire.in
        </title>

        <meta
          name="description"
          content="LushDesire.in offers 100% discreet delivery across India. Plain packaging, secure billing & complete privacy while buying sex toys online."
        />

        <meta
          name="keywords"
          content="discreet delivery India, sex toys discreet shipping, private delivery adult toys, anonymous packaging India, LushDesire discreet order"
        />

        <link
          rel="canonical"
          href="https://lushdesire.in/discreet-delivery"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      {/* 🔥 PAGE CONTENT */}
      <div
        style={{
          backgroundColor: "#FFF5F5",
          minHeight: "100vh",
          paddingTop: "120px", // navbar fix
          paddingBottom: "60px",
        }}
      >
        <div
          style={{
            maxWidth: "900px",
            margin: "auto",
            padding: "0 20px",
          }}
        >
          {/* ✅ MAIN H1 */}
          <h1 style={{ marginBottom: "20px", color: "#A61325" }}>
            100% Discreet Delivery Across India
          </h1>

          <p>
            At <strong>LushDesire</strong>, we understand that privacy matters.
            That’s why we ensure <strong>complete confidentiality</strong> for
            every order placed on <strong>LushDesire.in</strong>. From packaging
            to billing, your comfort and anonymity are fully protected.
          </p>

          {/* ✅ H2 */}
          <h2>Plain & Anonymous Packaging</h2>
          <p>
            All products are shipped in <strong>plain, unbranded boxes</strong>.
            There is no mention of product details, brand name, or adult content
            anywhere on the package.
          </p>

          {/* ✅ H2 */}
          <h2>Secure & Neutral Billing Name</h2>
          <p>
            Your bank statement will display a <strong>generic billing name</strong>.
            No sensitive or explicit information is ever shared with payment
            providers or visible on transaction records.
          </p>

          {/* ✅ H2 */}
          <h2>Complete Privacy Protection</h2>
          <p>
            Your personal information, order history, and delivery details are
            kept strictly confidential. We never share customer data with third
            parties without consent.
          </p>

          {/* ✅ H2 */}
          <h2>Trusted Discreet Shopping Experience</h2>
          <p>
            Thousands of customers across India trust <strong>LushDesire</strong>
            for safe, secure, and discreet shopping of personal wellness
            products. Your privacy is not an option — it’s our promise.
          </p>
        </div>
      </div>
    </>
  );
};

export default DiscreetDelivery;
